import React from 'react';
import Dialog from '../../BuildingBlocks/Dialogs/DialogStyleTwo/Dialog';
import Button from '../../BuildingBlocks/Button/Button';
import { makeStyles } from '@material-ui/styles';
import { Theme, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  textWrapper: {
    marginTop: theme.spacing(5),
  },
  button: {
    padding: `10px 32px`,
    borderRadius: theme.spacing(1.5),
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'end',
    marginTop: theme.spacing(5),
    width: '100%',
  },
  dialogContentContainer: {
    textAlign: 'center',
  },
  svgWrapper: {
    marginTop: theme.spacing(3),
  },
}));
interface DialogProps {
  closeDialog: (...args) => void;
  title: string;
  text: string;
  iconPath?: string;
}

export default function DialogSuccessMsg({
  closeDialog,
  title,
  text,
  iconPath,
}: DialogProps) {
  const classes = useStyles();
  return (
    <Dialog
      open={true}
      onClose={closeDialog}
      customContent={true}
      maxWidth={612}
    >
      <div className={classes.root}>
        <div className={classes.dialogContentContainer}>
          {iconPath && (
            <div className={classes.svgWrapper}>
              <img src={iconPath} alt="" />
            </div>
          )}
          <div className={classes.textWrapper}>
            <Typography variant="h5" style={{ fontWeight: 700 }}>
              {title}
            </Typography>
            <Typography variant="h5">{text}</Typography>
          </div>
        </div>
        <div className={classes.buttonsContainer}>
          <Button
            variant="contained"
            color="primary"
            onClick={closeDialog}
            className={`${classes.button}`}
          >
            <Typography variant="h6">
              <b>Close</b>
            </Typography>
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
